module.exports = __webpack_public_path__ + "static/icon-email.d03fd3b9.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon-email.png
// module id = 311
// module chunks = 2